export default class Folder {
  id = ''
  name = ''
  fileCounts = ''
  date = ''
  big = ''
  isAutoCreate = ''
  middle = ''
  ossKey = ''
  seqId = ''
  small = ''
  selected = false
  active = false
  entered = false

  naturalWidth = 0
  naturalHeight = 0
  maxWidth = 120
  maxHeight = 120
  showWidth = 120
  showHeight = 120

  loadData = function (jsonData) {
    this.id = jsonData.id
    this.name = jsonData.name
    this.fileCounts = jsonData.fileCounts
    this.date = jsonData.date
    this.big = jsonData.bigUrl
    this.isAutoCreate = jsonData.isAutoCreate
    this.middle = jsonData.middleUrl
    this.ossKey = jsonData.ossKey
    this.seqId = jsonData.seqId
    this.small = jsonData.smallUrl
  }

  isSameSmall = function (imageSrc) {
    var isSame = false
    if (imageSrc === this.small) {
      isSame = true
    }
    return isSame
  }

  computeShowSize = function (width, height) {
    this.naturalWidth = width
    this.naturalHeight = height
    var scaleW = this.naturalWidth / this.maxWidth
    var scaleH = this.naturalHeight / this.maxHeight
    var scale = (scaleW > scaleH) ? scaleW : scaleH
    this.showWidth = this.naturalWidth / scale
    this.showHeight = this.naturalHeight / scale
  }
}



// WEBPACK FOOTER //
// ./src/common/model/Folder.js